import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _5b923770 = () => interopDefault(import('../pages/devtools/index.vue' /* webpackChunkName: "pages/devtools/index" */))
const _19bf9c8c = () => interopDefault(import('../pages/devtools/market-links.vue' /* webpackChunkName: "pages/devtools/market-links" */))
const _b5626c64 = () => interopDefault(import('../pages/checkout-redirect/_signupType.vue' /* webpackChunkName: "pages/checkout-redirect/_signupType" */))
const _4af546ca = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _63de5612 = () => interopDefault(import('../pages/_locale/content-load-error.vue' /* webpackChunkName: "pages/_locale/content-load-error" */))
const _1d3a9ca9 = () => interopDefault(import('../pages/_locale/conversion-success.vue' /* webpackChunkName: "pages/_locale/conversion-success" */))
const _2ebccaf8 = () => interopDefault(import('../pages/_locale/guest-checkout.vue' /* webpackChunkName: "pages/_locale/guest-checkout" */))
const _50f08604 = () => interopDefault(import('../pages/_locale/_signupType.vue' /* webpackChunkName: "pages/_locale/_signupType" */))
const _4bab64a1 = () => interopDefault(import('../pages/_locale/_signupType/checkout.vue' /* webpackChunkName: "pages/_locale/_signupType/checkout" */))
const _227b4424 = () => interopDefault(import('../pages/_locale/_signupType/invite-landing.vue' /* webpackChunkName: "pages/_locale/_signupType/invite-landing" */))
const _5130d019 = () => interopDefault(import('../pages/_locale/_signupType/signup-page.vue' /* webpackChunkName: "pages/_locale/_signupType/signup-page" */))
const _3a6e6256 = () => interopDefault(import('../pages/_locale/_signupType/sponsor-search.vue' /* webpackChunkName: "pages/_locale/_signupType/sponsor-search" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/static/signup/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/devtools",
    component: _5b923770,
    name: "devtools"
  }, {
    path: "/devtools/market-links",
    component: _19bf9c8c,
    name: "devtools-market-links"
  }, {
    path: "/checkout-redirect/:signupType?",
    component: _b5626c64,
    name: "checkout-redirect-signupType"
  }, {
    path: "/",
    component: _4af546ca,
    name: "index"
  }, {
    path: "/:locale/content-load-error",
    component: _63de5612,
    name: "locale-content-load-error"
  }, {
    path: "/:locale/conversion-success",
    component: _1d3a9ca9,
    name: "locale-conversion-success"
  }, {
    path: "/:locale/guest-checkout",
    component: _2ebccaf8,
    name: "locale-guest-checkout"
  }, {
    path: "/:locale/:signupType?",
    component: _50f08604,
    name: "locale-signupType",
    children: [{
      path: "checkout",
      component: _4bab64a1,
      name: "locale-signupType-checkout"
    }, {
      path: "invite-landing",
      component: _227b4424,
      name: "locale-signupType-invite-landing"
    }, {
      path: "signup-page",
      component: _5130d019,
      name: "locale-signupType-signup-page"
    }, {
      path: "sponsor-search",
      component: _3a6e6256,
      name: "locale-signupType-sponsor-search"
    }]
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
